export const DocumentTypes = {
  AcademicReference: "academic-reference",
  DiplomaCopy: "diploma-copy",
};

export const DocumentTypeLabels = {
  [DocumentTypes.AcademicReference]: "Академична справка",
  [DocumentTypes.DiplomaCopy]: "Копие от диплома",
};
